import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    getErrors,
    getError,
    deleteError
}

function getErrors(query) {
    return new Promise((resolve, reject) => {
        Superagent
            .get(`${HOST_API}/errors`)
            .set('access', Storage.getItem('access'))
            .query(query)
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getError(errorId) {
    return new Promise((resolve, reject) => {
        Superagent
            .get(`${HOST_API}/errors/${errorId}`)
            .set('access', Storage.getItem('access'))
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function deleteError(errorId) {
    return new Promise((resolve, reject) => {
        Superagent
            .delete(`${HOST_API}/errors/${errorId}`)
            .set('access', Storage.getItem('access'))
            .end((err, res) => {
                resolve(res.body)
            })
    })
}
